var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 128,
    viewBox: "0 0 130 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 128,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8656 77.1764C79.2364 77.1764 90.8761 65.8047 90.8761 51.7647C90.8761 37.7247 79.2364 26.3529 64.8656 26.3529C50.4949 26.3529 38.8552 37.7247 38.8552 51.7647C38.8552 65.8047 50.4949 77.1764 64.8656 77.1764ZM64.8656 89.8823C47.5037 89.8823 12.8447 98.3953 12.8447 115.294V128H116.887V115.294C116.887 98.3953 82.2276 89.8823 64.8656 89.8823Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyUser);
export default __webpack_public_path__ + "static/media/emptyUser.9c30bede26d88afdb28d5b00138738bd.svg";
export { ForwardRef as ReactComponent };